var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.25C11 9.30078 8.5293 11.75 5.5 11.75C2.44922 11.75 0 9.30078 0 6.25C0 3.2207 2.44922 0.75 5.5 0.75C8.5293 0.75 11 3.2207 11 6.25ZM2.12695 3.86523C1.6543 4.55273 1.375 5.36914 1.375 6.25C1.375 8.52734 3.20117 10.375 5.5 10.375C6.38086 10.375 7.19727 10.0957 7.88477 9.62305L2.12695 3.86523ZM9.625 6.25C9.625 3.97266 7.77734 2.125 5.5 2.125C4.59766 2.125 3.78125 2.42578 3.09375 2.89844L8.85156 8.65625C9.32422 7.96875 9.625 7.15234 9.625 6.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCancel);
export default __webpack_public_path__ + "static/media/status-cancel.3228ad35ac81c005bb87858205c6fe0d.svg";
export { ForwardRef as ReactComponent };